import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-use";

import { Group } from "@/components/Group";
import { Text } from "@/components/Text";
import { MEDIA_SIZE_SM } from "@/core/media";
import { formatLocation } from "@/data/locations";
import { formatPhone } from "@/data/phones";
import { Flex } from "@/eworkitComponents";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";

interface Props extends IConsultantProfileSectionProps {}

export const InfoSection: React.FC<Props> = memo(({ record }) => {
  const { t } = useTranslation("session");

  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  const isPrivateProfile = !record.companyRole;

  return (
    <Flex direction="column" innerMargin="xs">
      <Group
        label={t("CONSULTANT_PROFILES.DETAIL.FIRST_NAME.LABEL")}
        labelWidth={4}
        fieldWidth={8}
        direction={isSmallScreen ? "column" : "row"}>
        <Text size="md" color="black" wordBreak="all">
          {record.firstName}
        </Text>
      </Group>
      <Group
        label={t("CONSULTANT_PROFILES.DETAIL.LAST_NAME.LABEL")}
        labelWidth={4}
        fieldWidth={8}
        direction={isSmallScreen ? "column" : "row"}>
        <Text size="md" color="black" wordBreak="all">
          {record.lastName}
        </Text>
      </Group>
      {!isPrivateProfile && (
        <Group
          label={t("CONSULTANT_PROFILES.DETAIL.COMPANY_POSITION.LABEL")}
          labelWidth={4}
          fieldWidth={8}
          direction={isSmallScreen ? "column" : "row"}>
          <Text size="md" color={record.position.name ? "black" : "grey3"} wordBreak="all">
            {record.position.name || t("CONSULTANT_PROFILES.DETAIL.WORK_PREFERENCES.NO_ITEMS")}
          </Text>
        </Group>
      )}
      <Group
        label={t("CONSULTANT_PROFILES.DETAIL.LOCATION.LABEL")}
        labelWidth={4}
        fieldWidth={8}
        direction={isSmallScreen ? "column" : "row"}>
        <Text size="md" color={record.location ? "black" : "grey3"}>
          {record.location
            ? formatLocation(record.location)
            : t("CONSULTANT_PROFILES.DETAIL.WORK_PREFERENCES.NO_ITEMS")}
        </Text>
      </Group>
      <Group
        label={t("CONSULTANT_PROFILES.DETAIL.PHONE.SECTION_HEADER")}
        labelWidth={4}
        fieldWidth={8}
        direction={isSmallScreen ? "column" : "row"}>
        <Text size="md" color={record.phone ? "black" : "grey3"}>
          {record.phone ? formatPhone(record.phone) : t("CONSULTANT_PROFILES.DETAIL.WORK_PREFERENCES.NO_ITEMS")}
        </Text>
      </Group>
    </Flex>
  );
});
